module.exports = __webpack_public_path__ + "static/media/ca_phe_hanoi_thumb.72768e16.webp";